<div class="header">
  <!-- Left: Chevron logo only -->
  <div class="left-section">
    <div class="hallmark"></div>
  </div>

  <!-- Center: WTV title -->
  <div class="center-section">
    <h1>WTV</h1>
  </div>

  <!-- Right: username + avatar (logged in) -->
  <div class="right-section" *ngIf="isLoggedIn">
    <div class="user-container" (click)="toggleDropdown()">
      <span class="username">Hello, {{ userName }}</span>
      <div class="avatar">{{ userInitials }}</div>
      <span class="dropdown-icon">▼</span>
    </div>
    <div class="dropdown" *ngIf="isDropdownOpen">
      <button (click)="logout()">Logout</button>
    </div>
  </div>

  <!-- Right: login button (logged out) -->
  <div class="right-section" *ngIf="!isLoggedIn">
    <button class="login-btn" (click)="login()">Login with SSO</button>
  </div>
</div>
